import { brandName, isAzaform } from "helpers/brand";

const META_TAGS = {
  "/register": {
    title: `Register - ${brandName}`,
    description: `Create an account on ${brandName} to start creating forms and collecting responses.`,
    keywords: `register, sign up, ${brandName}, online forms, form builder, feedback forms`,
    image: "socialpreview.png",
  },
  "/login": {
    title: `Login - ${brandName}`,
    description: `Access your ${brandName} account to manage forms and responses.`,
    keywords: `login, ${brandName}, online form builder, feedback management, forms`,
    image: "socialpreview.png",
  },
  "/": {
    title: `${brandName} - Home`,
    description: isAzaform
      ? "Build simple online forms and collect responses fast."
      : "Build simple yet professional online forms around your brand.",
    keywords: isAzaform
      ? "online form builder, simple forms, surveys, registrations"
      : "online form builder, feedback form builder, feedback management, feedback forms, personal branding",
    image: "socialpreview.png",
  },
  "/blog": {
    title: `Blog - ${brandName}`,
    description: isAzaform
      ? "Guides and tips on building online forms and collecting responses."
      : "Articles about the importance of feedback and building online forms to gather feedback.",
    keywords: isAzaform
      ? "online form builder blogs, form templates, QR forms, surveys"
      : "online form builder blogs, online form templates, free online form builder, feedback management, feedback forms",
    image: "socialpreview.png",
  },
};

export default META_TAGS;
